import React, { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

type InfoDisplayProps = {
  children: ReactNode
  header?: ReactNode
  variant?: 'info' | 'error'
}

const variantStyles = {
  info: {
    outerBg: '#E3EEEE',
    innerBg: '#F4FCFC',
  },
  error: {
    outerBg: '#FCEAEA',
    innerBg: '#FFF5F5',
  },
}

export function InfoDisplay({
  children,
  header,
  variant = 'info',
}: InfoDisplayProps) {
  const colors = variantStyles[variant]
  return (
    <Box
      padding="10px"
      borderRadius="5px"
      style={{ backgroundColor: colors.outerBg }}
    >
      {header}
      <Box
        padding="10px"
        borderRadius="5px"
        overflow="auto"
        maxHeight="180px"
        style={{ backgroundColor: colors.innerBg }}
      >
        {children}
      </Box>
    </Box>
  )
}

export function BorderedContainer({ children }: { children: ReactNode }) {
  return (
    <Box
      p={2}
      border={1}
      borderColor="grey.300"
      borderRadius={1}
      bgcolor="grey.50"
    >
      {children}
    </Box>
  )
}

export function SmallItalicText({
  children,
  color = 'text.secondary',
}: {
  children: ReactNode
  color?: string
}) {
  return (
    <Typography
      variant="body2"
      color={color}
      sx={{ ml: 2, fontStyle: 'italic' }}
    >
      {children}
    </Typography>
  )
}
